import React, { useEffect, useState, useContext, useRef } from "react";
import { getSalesReport, ListOrder, ListOrderById, get_product_order_details1, get_product_order_details2 } from "../../../../Utility/Api";
import { getFormattedCurrentDate2, NaviGate, shop_id } from "../../../../Utility/function";
import { WarehouseContext } from "../../../../Utility/UserContext";
import "./../table.css";
import * as XLSX from "xlsx";
import SalesPrintModal from "../../SalesWindow/modal/SalesPrintModal";
import { useNavigate } from "react-router-dom";

// Helper function to get current week range
const getCurrentWeek = () => {
    const today = new Date();
    const firstDay = new Date(today.setDate(today.getDate() - today.getDay()));
    const lastDay = new Date(today.setDate(today.getDate() - today.getDay() + 6));

    return {
        start: firstDay.toISOString().split('T')[0],
        end: lastDay.toISOString().split('T')[0]
    };
};

// Helper function to get week range from date
const getWeekRange = (dateString) => {
    const date = new Date(dateString);
    const firstDay = new Date(date.setDate(date.getDate() - date.getDay()));
    const lastDay = new Date(date.setDate(date.getDate() - date.getDay() + 6));

    return {
        start: firstDay.toISOString().split('T')[0],
        end: lastDay.toISOString().split('T')[0]
    };
};

const SalesReport = () => {
    const navigate = useNavigate();
    const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);
    const contentRef = useRef(null);

    const [filterType, setFilterType] = useState(() => {
        return sessionStorage.getItem("sales_report_filterType") || "daily";
    });
    const [selectedDate, setSelectedDate] = useState(() => {
        return sessionStorage.getItem("sales_report_selectedDate") || new Date().toISOString().split('T')[0];
    });
    const [selectedWeek, setSelectedWeek] = useState(() => {
        try {
            const saved = sessionStorage.getItem("sales_report_selectedWeek");
            return saved ? JSON.parse(saved) : getCurrentWeek();
        } catch {
            return getCurrentWeek();
        }
    });
    const [selectedMonth, setSelectedMonth] = useState(() => {
        return sessionStorage.getItem("sales_report_selectedMonth") || getFormattedCurrentDate2().substring(0, 7);
    });
    const [selectedYear, setSelectedYear] = useState(() => {
        return sessionStorage.getItem("sales_report_selectedYear") || new Date().getFullYear().toString();
    });
    const [customFromDate, setCustomFromDate] = useState(() => {
        return sessionStorage.getItem("sales_report_customFromDate") || "";
    });
    const [customToDate, setCustomToDate] = useState(() => {
        return sessionStorage.getItem("sales_report_customToDate") || "";
    });
    const [data, setData] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(() => {
        return sessionStorage.getItem("sales_report_selectedCustomer") || "";
    });
    const [paymentStatus, setPaymentStatus] = useState(() => {
        return sessionStorage.getItem("sales_report_paymentStatus") || "";
    });
    const [searchText, setSearchText] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [Details, setDetails] = useState({});
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [selectedReturnInvoice, setSelectedReturnInvoice] = useState(null);
    const [selectedOrder, setSelectedOrder] = useState([]);
    const [companyInfo, setCompanyInfo] = useState({
        name: "Company Name",
        address: "123 Business Street, City, State 12345",
        phone: "(123) 456-7890",
        email: "info@yourcompany.com"
    });

    useEffect(() => {
        if (shopItem) {
            setCompanyInfo({
                name: shopItem?.title || "",
                address: shopItem?.Address || "123 Business Street, City, State 12345",
                phone: shopItem?.phone1 || "",
                email: shopItem?.email || ""
            });
        }
    }, [shopItem]);

    // Save filters to sessionStorage when they change
    useEffect(() => {
        sessionStorage.setItem("sales_report_filterType", filterType);
    }, [filterType]);

    useEffect(() => {
        sessionStorage.setItem("sales_report_selectedDate", selectedDate);
    }, [selectedDate]);

    useEffect(() => {
        sessionStorage.setItem("sales_report_selectedWeek", JSON.stringify(selectedWeek));
    }, [selectedWeek]);

    useEffect(() => {
        sessionStorage.setItem("sales_report_selectedMonth", selectedMonth);
    }, [selectedMonth]);

    useEffect(() => {
        sessionStorage.setItem("sales_report_selectedYear", selectedYear);
    }, [selectedYear]);

    useEffect(() => {
        sessionStorage.setItem("sales_report_customFromDate", customFromDate);
    }, [customFromDate]);

    useEffect(() => {
        sessionStorage.setItem("sales_report_customToDate", customToDate);
    }, [customToDate]);

    useEffect(() => {
        sessionStorage.setItem("sales_report_selectedCustomer", selectedCustomer);
    }, [selectedCustomer]);

    useEffect(() => {
        sessionStorage.setItem("sales_report_paymentStatus", paymentStatus);
    }, [paymentStatus]);



    // Deriving fromDate and toDate from state variables directly on render
    const getDateRange = () => {
        let startDate = "";
        let endDate = "";

        switch (filterType) {
            case "daily":
                startDate = selectedDate;
                endDate = selectedDate;
                break;
            case "weekly":
                startDate = selectedWeek.start;
                endDate = selectedWeek.end;
                break;
            case "monthly":
                startDate = `${selectedMonth}-01`;
                const lastDay = new Date(
                    new Date(startDate).getFullYear(),
                    new Date(startDate).getMonth() + 1,
                    0
                ).getDate();
                endDate = `${selectedMonth}-${lastDay}`;
                break;
            case "yearly":
                startDate = `${selectedYear}-01-01`;
                endDate = `${selectedYear}-12-31`;
                break;
            case "custom":
                startDate = customFromDate;
                endDate = customToDate;
                break;
            default:
                break;
        }

        return { fromDate: startDate, toDate: endDate };
    };

    const { fromDate, toDate } = getDateRange();

    const fetchData = async (from, to) => {
        try {
            showLoader();
            const filter = `from_date=${from}&to_date=${to}&shop_id=${shop_id}&status=4`;
            const response = await getSalesReport(filter);
            if (response.data && response.data.data) {
                setData(response.data.data);
            }
            hideLoader();
        } catch (error) {
            hideLoader();
            console.error("Error fetching order data:", error);
        }
    };

    useEffect(() => {
        if (fromDate && toDate) {
            fetchData(fromDate, toDate);
        }
    }, [fromDate, toDate]);

    const handleWeekChange = (dateString) => {
        setSelectedWeek(getWeekRange(dateString));
    };

    const handlePrint = () => {
        // Create a new window for printing
        const printWindow = window.open('', '_blank');

        // Get the printable content
        const printContent = document.getElementById('printable-report').innerHTML;

        // Write the content to the new window
        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Sales Report</title>
                <style>
                    @media print {
                        @page {
                            size: A4 portrait;
                            margin: 0.5in;
                        }
                        body {
                            font-family: Arial, sans-serif;
                            font-size: 12pt;
                            color: #000;
                            background: #fff;
                        }
                        .print-container {
                            width: 100%;
                            max-width: 21cm;
                            margin: 0 auto;
                        }
                        .print-header {
                            text-align: center;
                            margin-bottom: 20px;
                            border-bottom: 2px solid #000;
                            padding-bottom: 15px;
                        }
                        .print-header h1 {
                            font-size: 20pt;
                            margin: 0;
                            color: #000;
                        }
                        .print-header p {
                            margin: 5px 0;
                            font-size: 11pt;
                        }
                        .report-info {
                            margin: 15px 0;
                            padding: 10px;
                            background-color: #f8f9fa;
                            border-radius: 5px;
                        }
                        .report-table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 15px 0;
                            font-size: 10pt;
                        }
                        .report-table th, .report-table td {
                            border: 1px solid #ddd;
                            padding: 8px;
                            text-align: left;
                        }
                        .report-table th {
                            background-color: #f2f2f2;
                            font-weight: bold;
                        }
                        .report-totals {
                            margin-top: 20px;
                            padding: 15px;
                            border: 1px solid #ddd;
                            border-radius: 5px;
                            background-color: #f9f9f9;
                        }
                        .total-row {
                            display: flex;
                            justify-content: space-between;
                            margin: 5px 0;
                        }
                        .total-amount {
                            font-weight: bold;
                            font-size: 13pt;
                        }
                        .text-success {
                            color: #28a745 !important;
                        }
                        .text-danger {
                            color: #dc3545 !important;
                        }
                        .footer {
                            margin-top: 30px;
                            text-align: center;
                            font-size: 10pt;
                            color: #6c757d;
                        }
                    }
                </style>
            </head>
            <body>
                ${printContent}
                <script>
                    // Print automatically when the window loads
                    window.onload = function() {
                        window.print();
                        // Close the window after printing
                        setTimeout(function() {
                            window.close();
                        }, 100);
                    };
                </script>
            </body>
            </html>
        `);

        printWindow.document.close();
    };

    const applyFilters = () => {
        let filtered = [...data];

        if (selectedCustomer) {
            filtered = filtered.filter(item => item.customer_name === selectedCustomer);
        }

        if (paymentStatus === "paid") {
            filtered = filtered.filter(item => item.purchase_unit != 2);
        } else if (paymentStatus === "unpaid") {
            filtered = filtered.filter(item => item.purchase_unit == 2);
        }

        if (searchText) {
            const search = searchText.toLowerCase();
            filtered = filtered.filter((sales) => {
                const poMatch = sales.unique_id?.toLowerCase().includes(search);
                const serialMatch = sales.obj_arr?.some((item) =>
                    item.serial_number?.toLowerCase().includes(search)
                );
                return poMatch || serialMatch;
            });
        }

        return filtered;
    };

    const filteredData = applyFilters();

    const exportToExcel = () => {
        const exportData = filteredData?.filter((data) => data.status != "-1").map((item) => ({
            Date: item.date,
            "Order No": item.unique_id,
            "Customer Name": item.customer_name,
            Amount: item.price_total,
            "Payment Status": item.purchase_unit == 2 ? "UnPaid" : "Paid"
        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sales_Report");
        XLSX.writeFile(wb, `Sales_Report_${fromDate}_to_${toDate}.xlsx`);
    };

    const handleGet = async (state) => {
        try {
            showLoader();
            handleClear();
            setDetails(state);
            const response = await get_product_order_details2(state.id, state.is_item_sale);
            if (response.data && response.data.data) {
                setSelectedInvoice(response.data.data);
            }
            if (response.data && response.data.return_sale) {
                setSelectedReturnInvoice(response.data.return_sale);
            }

            const order = await ListOrderById(state.order_id);
            if (order.data && order.data.data) {
                setSelectedOrder(order.data.payment);
            }
            hideLoader();
            navigate('/SalesReport_Pdf', {
                state: {
                    InvoiceDetail: state,
                    Products: response.data.data,
                    ReturnItem: response.data.return_sale,
                    Payment: order?.data?.payment,
                    paidAmount: order?.data?.payment?.filter((item) => item.mop != "2")
                        .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0),
                },
            });

        } catch (error) {
            handleClear();
            hideLoader();
            console.error("Error fetching order details:", error);
        }
    };

    const handleClear = () => {
        setDetails({})
        setSelectedInvoice([]);
        setSelectedReturnInvoice([]);
        setSelectedOrder([]);
    }

    const paidAmount = selectedOrder
        ?.filter((item) => item.mop != "2")
        .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

    const renderFilterControls = () => {
        switch (filterType) {
            case "daily":
                return (
                    <div className="col-md-2">
                        <div className="form-floating">
                            <input
                                type="date"
                                className="form-control"
                                id="selectedDate"
                                value={selectedDate}
                                onChange={(e) => setSelectedDate(e.target.value)}
                            />
                            <label htmlFor="selectedDate">Select Date</label>
                        </div>
                    </div>
                );
            case "weekly":
                return (
                    <div className="col-md-2">
                        <div className="form-floating">
                            <input
                                type="date"
                                className="form-control"
                                id="weekDate"
                                value={selectedWeek.start}
                                onChange={(e) => handleWeekChange(e.target.value)}
                            />
                            <label htmlFor="weekDate">Select Week</label>
                        </div>
                    </div>
                );
            case "monthly":
                return (
                    <div className="col-md-2">
                        <div className="form-floating">
                            <input
                                type="month"
                                className="form-control"
                                id="selectedMonth"
                                value={selectedMonth}
                                onChange={(e) => setSelectedMonth(e.target.value)}
                            />
                            <label htmlFor="selectedMonth">Select Month</label>
                        </div>
                    </div>
                );
            case "yearly":
                return (
                    <div className="col-md-2">
                        <div className="form-floating">
                            <input
                                type="number"
                                className="form-control"
                                id="selectedYear"
                                min="2000"
                                max="2100"
                                value={selectedYear}
                                onChange={(e) => setSelectedYear(e.target.value)}
                            />
                            <label htmlFor="selectedYear">Select Year</label>
                        </div>
                    </div>
                );
            case "custom":
                return (
                    <>
                        <div className="col-md-2">
                            <div className="form-floating">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="customFromDate"
                                    value={customFromDate}
                                    onChange={(e) => setCustomFromDate(e.target.value)}
                                />
                                <label htmlFor="customFromDate">From Date</label>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-floating">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="customToDate"
                                    value={customToDate}
                                    onChange={(e) => setCustomToDate(e.target.value)}
                                />
                                <label htmlFor="customToDate">To Date</label>
                            </div>
                        </div>
                    </>
                );
            default:
                return null;
        }
    };

    const goToCustomerDetails = (supplier) => {
        navigate(`/Customer_details?customer_id=${supplier.customer_id}`, {
            state: { supplier },
        });
    };

    // Calculate totals
    const totalSales = filteredData.reduce((sum, item) => sum + parseFloat(item.total || 0), 0);
    const totalPaidSales = filteredData
        .filter(item => item.purchase_unit != 2)
        .reduce((sum, item) => sum + parseFloat(item.total || 0), 0);
    const totalUnpaidSales = filteredData
        .filter(item => item.purchase_unit == 2)
        .reduce((sum, item) => sum + parseFloat(item.total || 0), 0);

    const salesSummary = filteredData.reduce(
        (acc, item) => {
            const total = Number(item.overall_price || 0);
            const remaining = Number(item.remaining || 0);
            const paid = total - remaining;

            acc.totalSales += total;
            acc.totalPaid += paid;
            acc.totalUnpaid += remaining;

            return acc;
        },
        {
            totalSales: 0,
            totalPaid: 0,
            totalUnpaid: 0
        }
    );

    const tableTotals = filteredData.reduce(
        (acc, item) => {
            const total = Number(item.overall_price || 0);
            const remaining = Number(item.remaining || 0);
            const paid = total - remaining;

            acc.total += total;
            acc.paid += paid;
            acc.unpaid += remaining;

            return acc;
        },
        { total: 0, paid: 0, unpaid: 0 }
    );


    return (
        <div className="page-content py-1">
            <NaviGate />
            <div className="card p-3 mx-2 overflow-y-scroll" style={{ minHeight: "90vh" }} ref={contentRef}>
                <div className="row mb-4 border-bottom justify-content-between align-items-center w-100">
                    <h5 className="text-start w-auto fw-bold mb-0">
                        Sales Report
                    </h5>
                    <div className="w-auto d-flex g-3 mt-0 justify-content-end flex-wrap">
                        <div className="col-md-2 me-2">
                            <div className="form-floating">
                                <select
                                    className="form-select"
                                    id="filterType"
                                    value={filterType}
                                    onChange={(e) => setFilterType(e.target.value)}
                                >
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="yearly">Yearly</option>
                                    <option value="custom">Custom Range</option>
                                </select>
                                <label htmlFor="filterType">Filter By</label>
                            </div>
                        </div>

                        {renderFilterControls()}

                        <div className="col-md-2 me-2">
                            <div className="form-floating">
                                <input
                                    className="form-control"
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    placeholder="Search"
                                />
                                <label>Search by Order No / S.No</label>
                            </div>
                        </div>

                        <div className="col-md-2 me-2">
                            <div className="form-floating">
                                <select
                                    className="form-control"
                                    value={paymentStatus}
                                    onChange={(e) => setPaymentStatus(e.target.value)}
                                >
                                    <option value="">All</option>
                                    <option value="paid">Paid</option>
                                    <option value="unpaid">Unpaid</option>
                                </select>
                                <label>Payment Type</label>
                            </div>
                        </div>

                        <div className="col-md-2 me-2">
                            <div className="form-floating">
                                <select
                                    className="form-control"
                                    value={selectedCustomer || ""}
                                    onChange={(e) => setSelectedCustomer(e.target.value)}
                                >
                                    <option value="">All Customers</option>
                                    {[...new Set(data.map((customer) => customer.customer_name).filter(Boolean))].map((customer, index) => (
                                        <option key={index} value={customer}>
                                            {customer}
                                        </option>
                                    ))}
                                </select>
                                <label>Customer</label>
                            </div>
                        </div>

                        <button
                            type="button"
                            className="btn btn-dark me-2"
                            onClick={handlePrint}
                        >
                            Print Report
                        </button>
                    </div>
                </div>

                <div className="d-flex justify-content-between mb-3">
                    <div>
                        <strong>Date Range:</strong> {fromDate} to {toDate}
                    </div>
                    <div>
                        <strong>Total Sales:</strong> {filteredData.length}
                    </div>
                </div>

                {/* Regular table view */}
                <div className="table-responsive text-center my-2 w-100 position-relative">
                    <table className="table table-sm table-bordered table-hover">
                        <thead className="table-dark">
                            <tr>
                                <th>S.No</th>
                                <th>Date</th>
                                <th>Order No</th>
                                <th>Customer Name</th>
                                <th>Amount (INR)</th>
                                <th>Remaining</th>
                                {/* <th>Profit/Loss</th> */}
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>

                            {filteredData.length > 0 ? (
                                filteredData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{new Date(item.create_date).toLocaleDateString()}</td>
                                        <td>{item.order_id}</td>
                                        {item.purchase_unit == 2 ?
                                            <td onClick={() => { goToCustomerDetails(item) }} className="text-info pointer"> {item.customer_name}</td>
                                            : <td>{item.customer_name}</td>
                                        }
                                        <td>{item.overall_price}</td>
                                        <td>{item.remaining}</td>
                                        {/* <td>{item.supplier_id || 'N/A'}</td> */}
                                        <td>
                                            {item.purchase_unit == 2 ? (
                                                <span className="text-danger fw-bold">Unpaid</span>
                                            ) : (
                                                <span className="text-success fw-bold">Paid</span>
                                            )}
                                        </td>
                                        <td>
                                            <img
                                                src='/assets/images/icons/view.png'
                                                onClick={() => handleGet(item)}
                                                height={"16px"}
                                                style={{ cursor: "pointer" }}
                                                alt="View"
                                                title="View Details"
                                            />
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" className="text-center">No records found</td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr className="fw-bold bg-light">
                                <td colSpan="4" className="text-end">TOTAL</td>

                                <td className="text-primary">
                                    ₹{tableTotals.total.toFixed(2)}
                                </td>

                                <td className="text-danger">
                                    ₹{tableTotals.unpaid.toFixed(2)}
                                </td>

                                <td className="text-success">
                                    {/* ₹{tableTotals.paid.toFixed(2)} */}
                                </td>

                                <td></td>
                            </tr>
                        </tfoot>
                    </table>

                </div>



                {/* Printable Report (Hidden from normal view) */}
                <div id="printable-report" style={{ display: 'none' }}>
                    <div className="print-container">
                        <div className="print-header">
                            <h1>{companyInfo.name}</h1>
                            <p>{companyInfo.address}</p>
                            <p>Phone: {companyInfo.phone} | Email: {companyInfo.email}</p>
                            <h2>Sales Report</h2>
                        </div>

                        <div className="report-info">
                            <p><strong>Report Period:</strong> {fromDate} to {toDate}</p>
                            <p><strong>Generated On:</strong> {new Date().toLocaleDateString()}</p>
                            {selectedCustomer && (
                                <p><strong>Customer:</strong> {selectedCustomer}</p>
                            )}
                            {paymentStatus && (
                                <p><strong>Payment Type:</strong> {paymentStatus === "paid" ? "Paid" : "Unpaid"}</p>
                            )}
                            {searchText && (
                                <p><strong>Filtered by:</strong> {searchText}</p>
                            )}
                        </div>

                        <table className="report-table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Date</th>
                                    <th>Order No</th>
                                    <th>Customer Name</th>
                                    <th>Amount (INR)</th>
                                    {/* <th>Profit/Loss</th> */}
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{new Date(item.create_date).toLocaleDateString()}</td>
                                            <td>{item.order_id}</td>
                                            <td>{item.customer_name}</td>
                                            <td>{Number(item.overall_price || 0).toFixed(3)}</td>
                                            {/* <td>{item.supplier_id || 'N/A'}</td> */}
                                            <td>
                                                {item.purchase_unit == 2 ? "Unpaid" : "Paid"}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: 'center' }}>
                                            No records found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {/* 
                        {filteredData.length > 0 && (
                            <div className="report-totals">
                                <h3>Summary</h3>
                                <div className="total-row">
                                    <span>Total Sales Count:</span>
                                    <span className="total-amount">{filteredData.length}</span>
                                </div>
                                <div className="total-row">
                                    <span>Total Sales Amount:</span>
                                    <span className="total-amount">{totalSales.toFixed(3)}</span>
                                </div>
                                <div className="total-row">
                                    <span>Paid Sales Amount:</span>
                                    <span className="text-success total-amount">{totalPaidSales.toFixed(3)}</span>
                                </div>
                                <div className="total-row">
                                    <span>Unpaid Sales Amount:</span>
                                    <span className="text-danger total-amount">{totalUnpaidSales.toFixed(3)}</span>
                                </div>
                            </div>
                        )} */}

                        {filteredData.length > 0 && (
                            <div className="report-totals">
                                <h3>Summary</h3>

                                <div className="total-row">
                                    <span>Total Sales Count:</span>
                                    <span className="total-amount">{filteredData.length}</span>
                                </div>

                                <div className="total-row">
                                    <span>Total Sales Amount:</span>
                                    <span className="total-amount">
                                        {salesSummary.totalSales.toFixed(2)}
                                    </span>
                                </div>

                                <div className="total-row">
                                    <span>Paid Sales Amount:</span>
                                    <span className="text-success total-amount">
                                        {salesSummary.totalPaid.toFixed(2)}
                                    </span>
                                </div>

                                <div className="total-row">
                                    <span>Unpaid Sales Amount:</span>
                                    <span className="text-danger total-amount">
                                        {salesSummary.totalUnpaid.toFixed(2)}
                                    </span>
                                </div>
                            </div>
                        )}


                        <div className="footer">
                            <p>Report generated on {new Date().toLocaleDateString()} at {new Date().toLocaleTimeString()}</p>
                        </div>
                    </div>
                </div>

                <SalesPrintModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                    ref={contentRef}
                    InvoiceDetail={Details}
                    Products={selectedInvoice}
                    ReturnItem={selectedReturnInvoice}
                    Payment={selectedOrder}
                    paidAmount={paidAmount}
                />
            </div>
        </div>
    );
};

export default SalesReport;